import { Flex } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { motion } from "framer-motion";

// Keyframes para animações
const ping = keyframes`
  0% { transform: scale(1); opacity: 1; }
  75%, 100% { transform: scale(2); opacity: 0; }
`;

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }x
`;

// Cores da paleta
const primaryRed = "#8C1614";
const darkRed = "#6A0B09";
const black = "#000000";
const white = "#FFFFFF";

// Animações
const pingAnimation = `${ping} 2s cubic-bezier(0, 0, 0.2, 1) infinite`;
const floatAnim = `${floatAnimation} 3s ease-in-out infinite`;

export const benefitClubBannerStyles = {
  mainBox: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "xl",
    boxShadow: "md",
    py: 10,
    px: [4, 6, 8],
    maxWidth: "100%",
    mx: "auto",
    mb: "6",
  },
  decorativeBox1: {
    position: "absolute",
    top: "-50px",
    right: "-30px",
    width: "250px",
    height: "250px",
    borderRadius: "full",
    bg: `${primaryRed}20`,
    zIndex: 0,
    overflow: "hidden",
  },
  decorativeBox2: {
    position: "absolute",
    bottom: "-40px",
    left: "-40px",
    width: "200px",
    height: "200px",
    borderRadius: "full",
    bg: `${darkRed}15`,
    zIndex: 0,
  },
  contentFlex: {
    position: "relative",
    zIndex: 1,
    direction: "column",
    align: "center",
    justify: "center",
    textAlign: "center",
  },
  iconBox: {
    position: "relative",
    mb: 6,
    as: motion.div,
    animation: floatAnim,
  },
  iconFlex: {
    width: "80px",
    height: "80px",
    borderRadius: "full",
    bg: `linear-gradient(135deg, ${primaryRed} 0%, ${darkRed} 100%)`,
    justify: "center",
    align: "center",
    boxShadow: "lg",
    color: white,
    fontSize: "3xl",
    position: "relative",
  },
  iconEffect1: {
    position: "absolute",
    top: "-2px",
    right: "-2px",
    width: "16px",
    height: "16px",
    borderRadius: "full",
    bg: primaryRed,
    opacity: "0.6",
    animation: pingAnimation,
  },
  iconEffect2: {
    position: "absolute",
    bottom: "-4px",
    left: "-4px",
    width: "20px",
    height: "20px",
    borderRadius: "full",
    bg: darkRed,
    opacity: "0.6",
    animation: pingAnimation,
    style: { animationDelay: "0.5s" },
  },
  exclusiveBadge: {
    position: "absolute",
    top: 4,
    right: 4,
    bg: darkRed,
    color: white,
    fontSize: "xs",
    px: 3,
    py: 1,
    borderRadius: "full",
    transform: "rotate(5deg)",
    fontWeight: "bold",
    boxShadow: "sm",
  },
  mainHeading: {
    fontWeight: "extrabold",
    color: black,
    mb: 4,
    letterSpacing: "tight",
    lineHeight: "1.2",
  },
  headingSpan: {
    color: primaryRed,
  },
  subHeadingSpan: {
    display: "block",
    fontSize: ["lg", "xl"],
    fontWeight: "medium",
    mt: 2,
    color: "gray.700",
  },
  descriptionText: {
    fontSize: ["md", "lg"],
    color: "gray.600",
    maxWidth: "600px",
    mb: 8,
    lineHeight: "tall",
  },
  featureStack: {
    mb: 10,
    wrap: "wrap",
    justify: "center",
  },
  featureItem: {
    align: "center",
    bg: white,
    px: 4,
    py: 2,
    borderRadius: "md",
    boxShadow: "sm",
    transition: "all 0.3s ease",
    _hover: {
      transform: "scale(1.02)",
      bg: "red.50",
    },
  },
  featureIcon: {
    mr: 2,
    fontSize: "lg",
  },
  featureText: {
    fontWeight: "medium",
    color: "gray.700",
  },
  containerButtons: {
    display: "flex",
    gap: 5,
    flexDirection: { base: "column", md: "row" },
    width: { base: "100%", md: "auto" },
    alignItems: "center",
  },
  ctaButton: {
    height: "60px",
    minWidth: { base: "100%", md: "280px" },
    bg: primaryRed,
    color: white,
    _hover: {
      bg: "red.600",
      transform: "translateY(-2px)",
      boxShadow: "lg",
    },
    _active: {
      bg: darkRed,
      transform: "translateY(0)",
    },
    borderRadius: "md",
    fontSize: "lg",
    fontWeight: "bold",
    transition: "all 0.3s ease",
    boxShadow: "md",
    px: 8,
  },
  googlePlayButton: {
    height: "60px",
    minWidth: { base: "100%", md: "280px" },
    bg: "#222831",
    color: white,
    _hover: {
      bg: "#393E46",
      transform: "translateY(-2px)",
      boxShadow: "lg",
      cursor: "pointer",
    },
    _active: {
      bg: darkRed,
      transform: "translateY(0)",
    },
    borderRadius: "md",
    fontSize: "lg",
    fontWeight: "bold",
    transition: "all 0.3s ease",
    boxShadow: "md",
    px: 8,
  },
  promoText: {
    mt: 4,
    fontSize: "sm",
    color: "gray.600",
  },
};

export const pageStyles = {
  pageContainer: {
    py: 10,
    px: 4,
    pl: ["6", "20"],
    pr: ["6", "20"],
  },
  mobileSeperator: {
    border: "1px solid silver",
    display: ["block", "none"],
    w: "100%",
  },
  headerContainer: {
    direction: "column",
    align: "center",
    mb: 6,
    mt: ["6", "0"],
  },
  title: {
    fontSize: "4xl",
    fontWeight: "bold",
    mb: 1,
    textAlign: "center",
    color: "gray.800",
    fontFamily: "merriweather",
  },
  underline: {
    width: ["25%", "8%"],
    height: "4px",
    bg: "red-wine",
    borderRadius: "full",
  },
};

export const AppPromoBannerStyles = {
  banner: {
    h: ["auto", "50vh", "40vh", "40vh", "45vh"],
    position: "relative",
    overflow: "visible",
    mt: "10%",
    py: 10,
    px: [4, 6, 2],
    maxWidth: "100%",
    mx: "auto",
    bg: "red-wine",
    boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.6), 0 4px 8px rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  // textContainer: {
  //   flex: 1,
  //   display: "flex",
  //   flexDirection: "column",
  //   alignItems: "flex-start",
  //   justifyContent: "center",
  //   h: "90%",
  //   pt: ["5", "20"],
  //   pb: ["5", "20"],
  //   pl: ["5", "20", "20", "20"],
  //   color: "white",
  //   width: ["100%", "50%  "],
  // },
  textContainer: {
    alignItems: ["center", "center", "flex-start"],
    flexDirection: "column",
    textAlign: ["center", "center", "left"],
    pt: ["5", "20"],
    pl: ["0", "0", "20"],
    color: "white",
  },
  // title: {
  //   fontSize: ['xl', '2xl', '2xl', '3xl', '4xl'],
  //   fontFamily: "merriweather",
  //   lineHeight: ['1.2rem', '1.8rem', '2rem', '2.6rem', '3rem'],
  //   fontWeight: "bold",
  //   marginBottom: "0",
  //   width: ["44%", "45%", "50%", "55%", "44%"],
  // },
  // subtitle: {
  //   fontSize: ['sm', 'sm', 'md', 'md', 'md'],
  //   marginBottom: "4",
  //   width: ["40%", "45%", "50%", "50%", "40%"],
  // },
  title: {
    fontSize: ["xl", "2xl", "3xl", "4xl"],
    fontFamily: "merriweather",
    lineHeight: "short",
    fontWeight: "bold",
    width: "100%",
  },
  subtitle: {
    fontSize: ["sm", "md"],
    mb: 4,
    width: "100%",
  },
  buttonsContainer: {
    zIndex: 1,
  },
  link: {
    mr: "5%",
    transition: "transform 0.3s ease",
    _hover: { transform: "scale(1.1)" },
  },
  ImageBox: {
    w: "150px",
    h: "40px",
    position: "relative",
  },
  image: {
    height: "45px",
  },
  // appImageContainer: {
  //   width: ['60%', '55%', '35%', '37%', '35%'],
  //   height: ['10%', '70%', '70%', '75%', '90%'],
  //   position: "absolute",
  //   top: '0%',
  //   right: ['0', '-10', '0', '20', '20'],
  //   display: "block",
  //   justifyContent: "flex-end",
  //   alignItems: "center",
  //   paddingRight: ['4', '20'],
  //   overflow: "visible",
  // },
  // appImageContainer: {
  //   width: ["100%", "80%", "40%", "35%"],
  //   mt: ["6", "8", "0"],
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  // },
  appImageContainer: {
    width: ["70%", "60%", "40%"],
    mt: ["4", "6", "0"],
    display: "flex",
    justifyContent: "center",
  },
  // appImage: {
  //   filter: "drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.5))",
  //   overFlow: "visible"
  // },
  // appImage: {
  //   width: "100%",
  //   height: "auto",
  //   maxWidth: "380px",
  //   filter: "drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.5))",
  // },
  appImage: {
    width: "100%",
    maxWidth: ["220px", "260px", "380px"],
    height: "auto",
  },
};

export const JoinUsSectionStylesSwiffy = {
  container: {
    pt: [4, null, 10],
    px: [0, 0, 0, 0],
    mb: [0, 0, 0, 0],
  },
  flexContainer: {
    direction: ["column", "column", "row", "row"],
    align: "center",
    gap: [0, null, 8],
  },
  boxContent: {
    w: ["auto", "auto", "20rem", "30rem"],
  },
  title: {
    fontSize: ["2xl", "2xl", "2xl", "4xl"],
    fontWeight: "bold",
    color: "gray.800",
    lineHeight: "1",
    w: "full",
    mt: [4, 0],
  },
  description: {
    fontSize: "md",
    color: "gray.700",
    mb: 6,
    mt: [4, null, 4],
  },
  button: {
    bg: "red.700",
    color: "white",
    fontWeight: "bold",
    _hover: { bg: "red.600" },
    display: ["none", null, "inline-flex"],
  },
  flexContent: {
    w: ["full", null, "full"],
    justify: "center",
    align: "center",
  },
  skeleton: {
    width: "100%",
    height: "400px",
    borderRadius: "lg",
  },
  boxSlider: {
    width: "100%",
    maxWidth: "960px",
    aspectRatio: "16/9",
    mx: "auto",
    position: "relative",
    overflow: "hidden",
  },
  boxNoNews: {
    width: "100%",
    height: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "gray.50",
    borderRadius: "lg",
    border: "1px solid",
    borderColor: "gray.200",
  },
  noNewsText: {
    color: "gray.500",
    fontSize: "lg",
    textAlign: "center",
  },
  mobileButton: {
    bg: "red.700",
    color: "white",
    fontWeight: "bold",
    width: "100%",
    _hover: { bg: "red.600" },
    display: ["flex", "none", "none"],
    mt: [5, 0],
    mb: [5, 0],
  },
};

export const SwiffyNewsSliderStyles = {
  textBox: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    p: 6,
    color: "white",
    zIndex: "2",
    px: "10",
    py: "10",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "column",
  },
  titleText: {
    fontFamily: "merriweather",
    fontSize: ["lg", "lg", "lg", "xl"],
    fontWeight: "bold",
    mb: 1,
    p: 1,
    bg: "rgba(0,0,0,0.6)",
    borderRadius: "lg",
    textAlign: "center",
  },
  descriptionText: {
    w: "fit-content",
    bg: "rgba(0, 0, 0, 0.5)",
    p: 1,
    borderRadius: "lg",
    fontSize: ["sm", "sm", "sm", "md"],
  },
  imageBox: {
    position: "relative",
    width: "100%",
    height: "100%",
    aspectRatio: "16/9", // Mantém o aspect ratio
    "& img": {
      objectFit: "cover",
      objectPosition: "center",
    },
  },
};
